import reloadCalendarEventsAndNotify from '../../../store/apis/reloadCalendarEventsAndNotify';

/**
 * Reloads all calendar folder caches upon receiving a reload notification
 */
export default function handleReloadNotification(folderId: string) {
    return reloadCalendarEventsAndNotify(folderId);
}
